// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button--2ha9K","SpinnerOverlay":"SpinnerOverlay--I2RVi","InnerSpinner":"InnerSpinner--3Yn9f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons/Buttons.local.css
// module id = 967
// module chunks = 3